module.exports = __webpack_public_path__ + "public/images/generated-learning-with-roblox.08f815f11a792fa7241803f4618055f7.jpg";